<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <h5 class="title is-5">{{ $t("devices.title") }}</h5>
    <div class="buttons">
      <router-link
        :to="{ name: 'devicesCreate', params: { projectId: projectId } }"
        class="button has-tooltip-arrow"
        :data-tooltip="$t('devices.create')"
      >
        <span class="icon is-small">
          <i class="fas fa-plus"></i>
        </span>
        <span>{{ $t("Create") }}</span>
      </router-link>
    </div>
    <div class="notification is-light is-info">
      {{ $t("devices.deviceInfo") }}
    </div>
    <div v-if="deviceError" class="notification is-light is-danger">
      {{ $t("devices.settingError") }}
      <ul>
        <li class="device-error">
          {{ $t("devices.connectError") }}
        </li>
        <li class="device-error">
          {{ $t("devices.connectError2") }}
        </li>
        <li class="device-error">
          {{ $t("devices.connectError3") }}
          <ul>
            <li class="device-error-list">
              {{ $t("devices.connectError3-1") }}
            </li>
            <li class="device-error-list">
              {{ $t("devices.connectError3-2") }}
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <table class="table is-fullwidth">
      <thead>
        <tr class="has-text-centered">
          <th>{{ $t("devices.deviceId") }}</th>
          <th>{{ $t("devices.deviceType") }}</th>
          <th>{{ $t("devices.deviceLocate") }}</th>
          <th>{{ $t("devices.battery") }}</th>
          <th>{{ $t("devices.antenna") }}</th>
          <th>{{ $t("devices.aiLevel") }}</th>
          <th>{{ $t("devices.enabledUndetectedarea") }}</th>
          <th>{{ $t("devices.lastConnect") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, deviceId) in deviceList"
          :key="deviceId"
          class="has-text-centered"
          :class="backgroundcolor(item.diffDay, item.hasError)"
        >
          <td>
            <router-link
              :to="{
                name: 'devicesView',
                params: { deviceId: item.deviceId },
              }"
            >
              {{ item.deviceId }}</router-link
            >
          </td>
          <td>{{ item.deviceType }}</td>
          <td>{{ item.deviceLocate }}</td>
          <td>
            <Battery
              :battery="item.battery"
              :antenna="item.antenna"
              :heartBeatError="item.heartBeatError"
            />
          </td>
          <td>
            <Antenna :antenna="item.antenna" />
          </td>
          <td>
            {{
              item.deviceType === "TrailCamera"
                ? item.aiLevel === "High"
                  ? $t("devices.highAILevel")
                  : item.aiLevel === "Mid"
                  ? $t("devices.midAILevel")
                  : item.aiLevel === "Low"
                  ? $t("devices.lowAILevel")
                  : item.aiLevel === ""
                  ? $t("devices.defaultAILevel")
                  : ""
                : "ー"
            }}
          </td>
          <td>
            {{
              item.enabledUndetectedarea === true
                ? $t("devices.undetectedareaStataus.enable")
                : item.enabledUndetectedarea === false
                ? $t("devices.undetectedareaStataus.disable")
                : ""
            }}
          </td>
          <td>
            <span :data-tooltip="item.dateTime">
              <span v-if="item.diffDay != ''">{{ item.diffDay }}</span>
              <span v-else>{{ $t("devices.notinoperation") }}</span>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb";
import Antenna from "@/components/devices/Antenna";
import Battery from "@/components/devices/Battery";
import imsr from "@/imsr-api";
import imsrc from "@/imsr-common";
import { computed, ref } from "@vue/reactivity";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  components: {
    Breadcrumb,
    Battery,
    Antenna,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const deviceList = ref([]);
    const deviceError = ref(false);
    const breadcrumb = ref([
      {
        title: "Home",
        path: {
          name: "dashboard",
          params: { projectId: route.params.projectId },
        },
      },
      { title: "Device Config", path: "#", isActive: true },
    ]);
    const getList = async () => {
      try {
        const params = {
          tenantId: store.getters.tenantId,
          projectId: route.params.projectId,
        };
        const res = await imsr.imsrGetApi("/devices/list", params);
        res.forEach((item) => {
          var diffDay = "";
          var dateTime = "";
          if (item.heartBeatUpdateTime) {
            diffDay = imsrc.dateDiff(item.heartBeatUpdateTime);
            dateTime = imsrc.dateFormat(item.heartBeatUpdateTime);
          }
          let hasError = false;
          if (item.deviceSetting === "JPEG" || item.heartBeatError) {
            deviceError.value = true;
            hasError = true;
          }
          if (!item.aiLevel || item.aiLevel === "") {
            item.aiLevel = "Mid";
          }

          deviceList.value.push({
            deviceId: item.deviceId,
            deviceType: item.deviceType,
            deviceLocate: item.deviceLocate,
            ipAddress: item.ipAddress,
            battery: item.battery,
            antenna: item.antenna,
            antennaRawData: item.antennaRawData,
            diffDay: diffDay,
            dateTime: dateTime,
            deviceSetting: item.deviceSetting,
            hasError: hasError,
            aiLevel: item.aiLevel,
            enabledUndetectedarea: item.enabledUndetectedarea,
            heartBeatError: item.heartBeatError,
          });
        });
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
    };
    getList();

    return {
      deviceList,
      projectId: computed(() => route.params.projectId),
      breadcrumb,
      deviceError,
    };
  },

  methods: {
    backgroundcolor(diffDay, hasError) {
      if (diffDay == "") {
        return "imsr-notinoperation";
      } else if (hasError) {
        return "imsr-danger";
      }
    },
  },
};
</script>
<style>
.imsr-danger {
  background-color: hsl(347, 90%, 96%);
}
.imsr-notinoperation {
  background-color: hsl(183, 90%, 96%);
}
.device-error {
  list-style: disc;
  margin-top: 0.5em;
  margin-left: 1em;
}
.device-error-list {
  list-style: decimal;
  margin-top: 0.5em;
  margin-left: 2em;
}
</style>
